import BlockedList from "./BlockedList";

export default class BlockedTasksList extends BlockedList {
    constructor($containerEl, entities, otherBlockedTaskCount) {
        super($containerEl, entities);
        this.otherBlockedTaskCount = otherBlockedTaskCount;
    }
    getEntitySubtitle(entity)
    {
        return CustomerStore.get(entity.customerId).name + " / " + ProjectStore.get(entity.projectId).name
    }

    getEntityTitle(entity)
    {
        return entity.name
    }

    additionListItems()
    {
        if (this.otherBlockedTaskCount == 0)
            return [];
        else if (this.otherBlockedTaskCount == 1)
            return [{title: messageResource.getMessage("delete.confirm.dialog.can_not_deleted.other_task")}];
        else
            return [{title: messageResource.getMessage("delete.confirm.dialog.can_not_deleted.other_tasks", [this.otherBlockedTaskCount])}];

    }
}



// WEBPACK FOOTER //
// ./web/js/cptManagement/deleteConfirmationDialog/BlockedTasksList.js